import Cookies from 'js-cookie';
import { pathOr } from 'lodash/fp';
import { createSelector } from 'reselect';

import { storeSelector } from '..';
import { AppState } from '../state';
import { SessionStateInterface } from './state';

export const sessionStoreSelector = (state: AppState) =>
  storeSelector('session', state) as SessionStateInterface;

export const getToken = createSelector(
  sessionStoreSelector,
  (store: SessionStateInterface) =>
    Cookies.get('auth_token') ||
    store.token ||
    process.env.REACT_APP_TEST_TOKEN ||
    ''
);

export const getCustomerInfo = createSelector(
  sessionStoreSelector,
  (store: SessionStateInterface) => store.customer || {}
);

export const getUserInfo = createSelector(
  sessionStoreSelector,
  (store: SessionStateInterface) => store.userInfo || {}
);

export const getRedirectTo = createSelector(
  sessionStoreSelector,
  (store: SessionStateInterface) => store.redirectTo || undefined
);

export const isValidToken = createSelector(
  sessionStoreSelector,
  (state: SessionStateInterface) => !!state.token
);

export const getErrorMessage = createSelector(
  sessionStoreSelector,
  pathOr('', ['error'])
);

export const getCurrentRolesList = createSelector(
  sessionStoreSelector as any,
  pathOr([], ['userInfo', 'roles'])
);
